import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { makeStyles, Box, Divider, Theme } from '@material-ui/core'

import SalesHeader from '../SalesHeader/SalesHeader'
import Sidebar from '../Sidebar/Sidebar'
import StepperNavigation from '../Stepper/Stepper'
import Title from '../Title/Title'

import SalesModal from '~/modal/components/SalesModal'
import PATHS from '~/router/paths'
import Routes from '~/router/Routes'

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    width: '100vw',
    flex: '2',
    maxHeight: '100vh',
    overflowY: 'auto',
  },
  margin: {
    [theme.breakpoints.down('md')]: {
      'margin-right': '-250px',
    },
  },
  sidebar: {
    marginTop: theme.spacing(14),
    minHeight: '100%',
    display: 'flex',
    maxHeight: '100vh',
  },
  divider: {
    height: '2px',
  },
  container: {
    marginTop: theme.spacing(8),
    paddingBottom: theme.spacing(12),
  },
  root: {
    maxWidth: '1175px',
    minWidth: '700px',
    width: '90%',
  },
}))

export default function Layout() {
  const { wrapper, sidebar, divider, container, margin, root } = useStyles()
  const location = useLocation()
  const isSalePage = location.pathname.includes(PATHS.SALES_START)

  const scrollable = document.getElementById('scroll')

  useEffect(() => {
    scrollable?.scrollTo(0, 0)
  }, [location])

  return (
    <>
      <SalesHeader />
      <Box display="flex" justifyContent="space-between" width="100%" overflow="hidden">
        <Box className={!isSalePage ? `${wrapper} ${margin}` : wrapper} id="scroll">
          <Title />
          <Divider className={divider} />
          <StepperNavigation />
          <Box className={container} justifyContent="center" display="flex">
            <Box className={root}>
              <Routes />
            </Box>
          </Box>
        </Box>
        {!isSalePage && (
          <Box className={sidebar}>
            <Sidebar />
          </Box>
        )}
      </Box>
      <SalesModal />
    </>
  )
}
